import { RouterProvider } from 'react-router';
import { router } from './routes';
import { Suspense, useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { authService } from '../services';

function RouterFallback() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-blue-600 animate-spin mx-auto mb-4" />
        <p className="text-slate-600 font-medium">Loading...</p>
      </div>
    </div>
  );
}

export default function App() {
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    authService.checkLogin()
      .then((response) => {
        if (response.success) {
          window.location.replace('/home');
        } else {
          setIsChecking(false);
        }
      })
      .catch(() => {
        setIsChecking(false);
      });
  }, []);

  if (isChecking) {
    return <RouterFallback />;
  }

  return (
    <Suspense fallback={<RouterFallback />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}